module.exports = "/packs/shares-4930613-0fa07b16f2c46aa2394b43974b24ad35.png";